module.exports = __webpack_public_path__ + "static/media/bg-produtos.e2984683.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/BannerTop/bg-produtos.png
// module id = 645
// module chunks = 0